<style lang="less" scoped>
	div {
		color: #333;
	}

	/deep/ .el-tag {
		background-color: #ecf5ff !important;
		// color: #fff;
		color: #409EFF;
		border-color: #d9ecff;
	}

	/deep/ .el-tag .el-tag__close {
		color: #fff;
	}


	.addinput {
		background: #fff;
		padding: 1rem;

		.addinputtop {
			width: 100%;
			height: 4rem;
			background: #fff;
			border-left: 4px solid #FFC107;
			padding: 0.7rem 0 0 1rem;
			margin-bottom: 1rem;
			box-sizing: border-box;

			p:first-child {
				font-size: 1.2rem;
				color: #333;

			}

			p:last-child {
				font-size: 0.8rem;
				color: #77818e;

			}
		}

		.addform {
			display: flex;
			justify-content: center;
			flex-direction: column;

			label:last-child {
				border-bottom: 1px solid #ccc;
			}

			label,
			.labelas {
				textarea {
					color: #333;
				}

				display: block;
				width: 100%;
				padding: 1rem 0;
				border-top: 1px solid #ccc;
				box-sizing: border-box;

				.labelchiles {
					margin: 0 auto;
					display: flex;
					align-items: center;

					p {
						// width: 5vw;
						text-align: right;
						margin-right: 1rem;
						color: rgb(74, 83, 94);
						font-size: 0.8rem;
					}
				}
			}

		}

		.fromsbtn {
			// width: 50%;
			margin: 1rem auto;
			display: flex;
			align-items: center;
			justify-content: center;


			button {
				margin: 0 1rem;
				padding: 0.6rem 2rem;
				border-radius: 2px;
				background-color: #F7F7F7;
				color: #333;
				border: 1px solid #ccc;
			}

			button:first-child {
				background-color: #3071A9;
				color: #fff;
			}

			button:hover {
				background-color: #1f92ea;
			}

			button:last-child:hover {
				background-color: #d9d9d9;
			}


		}

	}


	.el-tag+.el-tag {
		margin-left: 10px;
	}

	.button-new-tag {
		margin-left: 10px;
		height: 32px;
		line-height: 30px;
		padding-top: 0;
		padding-bottom: 0;
	}

	.input-new-tag {
		width: 90px;
		margin-left: 10px;
		vertical-align: bottom;
	}
</style>


<template>
	<div>
		<titles titlename="添加实训室" titlecontent="添加实训室" :mbx="paths"></titles>
		<div class="addinput">
			<div class="addinputtop">
				<p>实训室基本信息</p>
				<p>请填写实训室基本信息，实训室介绍信息</p>
			</div>
			<form class="addform">
				<label>
					<div class="col-xs-12 col-sm-10 col-md-8 col-lg-8 labelchiles">
						<p class="col-xs-6 col-sm-6 col-md-4 col-lg-2">实训室名称<span style="color: red;">*</span></p>
						<input type="text" class="form-control" v-model="roomstrain.tr_name" placeholder="请输入实训室名称">
					</div>
				</label>
				<label>
					<div class="col-xs-12 col-sm-10 col-md-8 col-lg-8 labelchiles">
						<p class="col-xs-6 col-sm-6 col-md-4 col-lg-2">实训室编号<span style="color: red;">*</span></p>
						<input type="text" class="form-control" placeholder="请输入实训室编号" v-model="roomstrain.tr_billNo">
					</div>
				</label>
				<label>
					<div class="col-xs-12 col-sm-10 col-md-8 col-lg-8 labelchiles">
						<p class="col-xs-6 col-sm-6 col-md-4 col-lg-2">所属院校<span style="color: red;">*</span></p>
						<select v-model="roomstrain.si_guid" class="form-control" id="exampleFormControlSelect1" @change="GetuserSelects()">
							<option value=""> -- 请选择所属院校 --</option>
							<option v-for="(item,index) in schoollist" :key="index" :label="item.si_name_cn" 
								:value="item.si_guid">
								{{item.si_name_cn}}
							</option>
						</select>
					</div>
				</label>

				<label>
					<div class="col-xs-12 col-sm-10 col-md-8 col-lg-8 labelchiles">
						<p class="col-xs-6 col-sm-6 col-md-4 col-lg-2">实训室地址</p>
						<input type="text" class="form-control" placeholder="请输入实训室地址" v-model="roomstrain.tr_address">
					</div>
				</label>
				<label>
					<div class="col-xs-12 col-sm-10 col-md-8 col-lg-8 labelchiles" style="position: relative;">
						<p class="col-xs-6 col-sm-6 col-md-4 col-lg-2">实训室责任人</p>
						<div style="width: 100%;height: 100%;">
							<el-select v-model="isshowmanid" placeholder="请选择用户" multiple @change="changeusers" >
								<el-option v-for="item in ternerlist" :key="item.ui_guid" :label="item.ui_realName"
									:value="item.ui_guid">
									<span style="float: left">{{ item.ui_realName }}</span>
									<span
										style="float: right; color: #8492a6; font-size: 13px">{{ item.ui_mobile }}</span>
								</el-option>
							</el-select>
						</div>
						<!-- <input type="text" class="form-control" placeholder="请输入实训室责任人"
							v-model="roomstrain.tr_maintenancer" @input="trmainchange()" @click="isshowman = true">
						
						<div class="downlay" v-if="isshowman">
							<el-collapse-transition>
								<div style="width: 100%;height: 100%;">
									<div v-show="ternerlist.length == 0">
										<el-empty description="请选择学校"></el-empty>
									</div>
									<div style="display: flex;" v-show="ternerlist.length > 0">
										<div style="width: 33.3%;display: flex;align-items: center;justify-content: space-around;height: 30px;">
											<p>用户名</p>
											<p>电话</p>
										</div>
										<div style="width: 33.3%;display: flex;align-items: center;justify-content: space-around;height: 30px;">
											<p>用户名</p>
											<p>电话</p>
										</div>
										<div style="width: 33.3%;display: flex;align-items: center;justify-content: space-around;height: 30px;">
											<p>用户名</p>
											<p>电话</p>
										</div>
									</div>
									
									<ul v-show="ternerlist.length > 0"
										style="width: 100%;display: flex;flex-wrap: wrap;align-items: center;justify-items: center;">
										<li v-for="item in ternerlist" :key="item.ui_guid" @click="changeusers(item)"
											style="border-right: 1px solid;cursor: pointer;width: 33.3%;display: flex;align-items: center;justify-content: space-around;height: 30px;">
											<p>{{item.ui_realName}}</p>
											<p>{{item.ui_mobile}}</p>
										</li>
									</ul>
								</div>
							</el-collapse-transition>
						</div> -->
					</div>
				</label>
				<label>
					<div class="col-xs-12 col-sm-10 col-md-8 col-lg-8 labelchiles">
						<p class="col-xs-6 col-sm-6 col-md-4 col-lg-2">责任人电话</p>
						<input type="text" class="form-control" placeholder="请输入责任人电话" v-model="roomstrain.tr_mobile">
					</div>
				</label>
				<label>
					<div class="col-xs-12 col-sm-10 col-md-8 col-lg-8 labelchiles">
						<p class="col-xs-4 col-sm-4 col-md-4 col-lg-2">备注</p>
						<input type="text" class="form-control" placeholder="备注" v-model="roomstrain.tr_remark">
					</div>
				</label>
				<!-- <label>
					<div class="col-xs-12 col-sm-10 col-md-8 col-lg-8 labelchiles">
						<p class="col-xs-4 col-sm-4 col-md-4 col-lg-2">责任人电话</p>
						<input type="text" class="form-control" placeholder="请输入责任人电话" v-model="roomstrain.tr_mobile">
					</div>
				</label> -->
				<div class="labelas">
					<div class="col-xs-12 col-sm-10 col-md-8 col-lg-8 labelchiles">
						<p class="col-xs-6 col-sm-6 col-md-4 col-lg-2">实训室图片</p>
						<upload :filelist="sxsfilelist"></upload>
					</div>
				</div>


				<!-- <label>
					<div class="col-xs-12 col-sm-10 col-md-8 col-lg-8 labelchiles">
						<p class="col-xs-4 col-sm-4 col-md-4 col-lg-2">设备MAC地址</p>
						<input type="text" class="form-control" placeholder="请输入设备MAC地址"  >
					</div>
				</label>
				<label>
					<div class="col-xs-12 col-sm-10 col-md-8 col-lg-8 labelchiles">
						<p class="col-xs-4 col-sm-4 col-md-4 col-lg-2">设备id地址</p>
						<input type="text" class="form-control" placeholder="请输入设备id地址" >
					</div>
				</label> -->
				<div class="labelas">
					<div class="col-xs-12 col-sm-10 col-md-8 col-lg-8 labelchiles">
						<p class="col-xs-6 col-sm-6 col-md-4 col-lg-2">Tag</p>
						<el-tag :key="tag" v-for="tag in dynamicTags" closable :disable-transitions="false"
							@close="handleClose(tag)">
							{{tag}}
						</el-tag>
						<div style="width: 4rem;">
							<el-input class="input-new-tag" v-if="inputVisible" v-model="inputValue" ref="saveTagInput"
								size="small" @keyup.enter.native="handleInputConfirm" @blur="handleInputConfirm">
							</el-input>
							<button v-else size="small" class="button-new-tag" @click="showInput">点击新增</button>
						</div>
						<!-- <button v-if="tapnem<=4" class="button-new-tag" size="small"></button> -->
					</div>
				</div>
				<label>
					<div class="col-xs-12 col-sm-10 col-md-8 col-lg-8 labelchiles">
						<p class="col-xs-4 col-sm-6 col-md-4 col-lg-2">实训室说明</p>
						<textarea class="form-control" rows="10" v-model="roomstrain.tr_introduction"></textarea>
					</div>
				</label>
			</form>
			<div class="fromsbtn col-xs-12 col-sm-10 col-md-8 col-lg-8">
				<button @click="addtrainroom()" v-preventReClick>提交</button>
				<button>取消</button>
			</div>
		</div>
	</div>
</template>

<script>
	import titles from "@/components/title/title.vue"
	import upload from "@/components/upload/upload.vue"
	import {
		getAddTrain,
		getTrainEquipmentList

	} from "@/request/api/trainroom/trainroom.js"
	import {
		GetUserSelect,
		GetbjGetSchoolList,
	} from "@/request/api/mange/mange.js"

	import AppOptions from '@/config/AppOptions.vue';

	export default {
		data() {
			return {
				ternerlist: [],
				maintenancer: [],
				maintenancerid: [],
				isshowmanid: "",
				// 院校不分页
				schoollist: [],
				userSingleobj: {
					si_guid: ""
				},
				sxsfilelist: [],
				// 标题组件
				paths: [{
						path: "/device/trainingmange",
						name: "实训管理"
					},
					{
						path: "/device/addmanges",
						name: "添加实训室"
					}
				],
				// tag组件
				dynamicTags: [],
				inputVisible: false,
				inputValue: '',
				// 新增实训室
				roomstrain: {
					sx_tr_guid: "",
					tr_name: "",
					tr_billNo: "",
					tr_maintenancer: "",
					tr_mobile: "",
					tr_openNum: "",
					tr_tag: "",
					tr_isOpen: "true",
					tr_address: "",
					tr_introduction: "",
					tr_videoMonitoringURL: "",
					tr_remark: "",
					si_guid: "",
					trainPicPath: "",
					tr_maintenancerid: ""
				},
				// 用户列表上传
				usernamelist: [],
				usermobilelist: [],
				usermaintenanceridlist: []

			}
		},
		created() {
			AppOptions.appEmpty = false;
		},
		beforeMount() {
			GetbjGetSchoolList().then(res => {
				// console.log(res, "院校不分页")
				this.schoollist = res.data.data

			})

			this.GetuserSelects()

		},
		updated() {

		},
		methods: {
			trmainchange() {
				this.isshowman = true
				// console.log(this.isshowman,"获取学生1111")
				if (this.roomstrain.si_guid != "") {
					this.GetuserSelects()
				}

			},
			// 获取用户
			GetuserSelects() {
				let datas = {
					pageIndex: 1,
					pageSize: 100,
					ui_userName: this.roomstrain.tr_maintenancer,
					si_guid: this.roomstrain.si_guid,
					ut_guid: ""
				}
				// console.log(this.isshowman)

				GetUserSelect(datas).then(res => {
					// console.log(res.data.data,"获取学生222")
					this.ternerlist = res.data.data.list
				})
			},

			// 修改责任人
			changeusers(itm) {
				let ternerobjmobile  = []
				let ternerobjuiguid  = []
				let maintenancerlist = []
				itm.forEach(itme=>{
					this.ternerlist.forEach(it=>{
						if(itme == it.ui_guid){
							ternerobjmobile.push(it.ui_mobile)
							ternerobjuiguid.push(it.ui_guid)
							maintenancerlist.push(it.ui_realName)
						}
					})
				})
				// console.log("修改责任人",ternerobjlist)
				this.roomstrain.tr_maintenancer = maintenancerlist.join(",")
				this.roomstrain.tr_mobile = ternerobjmobile.join(",")
				this.roomstrain.tr_maintenancerid  = ternerobjuiguid.join(",")
				
				// this.GetuserSelects(itm)
				// usernamelist=[]
				// usermobilelist:[]
				// usermaintenanceridlist:[]


				// this.roomstrain.tr_maintenancer = itm.ui_realName
				// this.roomstrain.tr_mobile = itm.ui_mobile
				// this.roomstrain.tr_maintenancerid = itm.ui_guid
				// this.isshowman = false
			},

			// 提交
			addtrainroom() {
				let roomstrain = {
					sx_tr_guid: "",
					tr_name: this.roomstrain.tr_name,
					tr_billNo: this.roomstrain.tr_billNo,
					tr_maintenancer: this.roomstrain.tr_maintenancer,
					tr_mobile: this.roomstrain.tr_mobile,
					tr_openNum: 8,
					tr_tag: this.dynamicTags.join("#"),
					tr_isOpen: "true",
					tr_address: this.roomstrain.tr_address,
					tr_introduction: this.roomstrain.tr_introduction,
					tr_videoMonitoringURL: "",
					tr_remark: this.roomstrain.tr_remark,
					si_guid: this.roomstrain.si_guid,
					trainPicPath: this.$store.state.trainimg,
					tr_maintenancerid: this.roomstrain.tr_maintenancerid
				}
				let fromdata = new FormData()

				fromdata.append("sx_tr_guid", roomstrain.sx_tr_guid)

				fromdata.append("tr_name", roomstrain.tr_name)
				fromdata.append("tr_billNo", roomstrain.tr_billNo)
				fromdata.append("tr_maintenancer", roomstrain.tr_maintenancer)
				fromdata.append("tr_mobile", roomstrain.tr_mobile)
				fromdata.append("tr_openNum", roomstrain.tr_openNum)
				fromdata.append("tr_tag", roomstrain.tr_tag)
				fromdata.append("tr_isOpen", roomstrain.tr_isOpen)
				fromdata.append("tr_address", roomstrain.tr_address)
				fromdata.append("tr_introduction", roomstrain.tr_introduction)
				fromdata.append("tr_videoMonitoringURL", roomstrain.tr_videoMonitoringURL)
				fromdata.append("tr_remark", roomstrain.tr_remark)
				fromdata.append("si_guid", roomstrain.si_guid)
				fromdata.append("tr_maintenancerid", roomstrain.tr_maintenancerid)

				// roomstrain.sx_tr_guid.append("filedata",roomstrain.trainPicPath)


				// roomstrain.trainPicPath.forEach((item, index) => {
				// 	fromdata.append("filedata", item)
				// })
				for (let i = 0; i < roomstrain.trainPicPath.length; i++) {
					fromdata.append("filedata", roomstrain.trainPicPath[i])

				}



				getAddTrain(fromdata).then(res => {
					if (res.data.code == 1) {
						this.$message({
							message: '恭喜你，' + res.data.msg,
							type: 'success'
						});
						this.roomstrain = {}
						this.sxsfilelist = []
						this.dynamicTags = []
						this.isshowmanid =[]
						this.roomstrain.si_guid = ""
					} else {
						// this.$message(res.data.msg);
					}
				})
			},
			// 标签
			handleClose(tag) {
				this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
			},

			showInput() {
				this.inputVisible = true;
				this.$nextTick(() => {
					this.$refs.saveTagInput.$refs.input.focus();
				});
			},

			handleInputConfirm() {
				let inputValue = this.inputValue;
				if (inputValue) {
					this.dynamicTags.push(inputValue);
				}
				this.inputVisible = false;
				this.inputValue = '';
			},
			opentag() {
				// console.log(111)
			},
			deletag(i) {
				// console.log(i)
				this.tags.splice(i, 1)
			}
		},
		components: {
			titles,
			upload
		}
	}
</script>

<style scoped lang="less">
	.downlay {
		width: 82%;
		min-height: 200px;
		background-color: #fff;
		position: absolute;
		top: 103%;
		left: 18%;
		border-radius: 10px;
		border: 1px solid #ccc;
	}

	.downlay ul li:nth-of-type(3n) {
		border-right: 0px !important;
	}

	/deep/ .el-select {
		width: 100%;


		input::-webkit-input-placeholder {
			/* placeholder颜色 */
			color: #6C757D;
			
		}

	}
</style>